// Generate the order number for desktop cards
const getCardOrder = (index: number, count: number) =>
    // index of card / cards per row + 1 (so the end of the row has the correct index)
    Math.floor((index + 1) / (count + 1));

export default getCardOrder;
